import { useEffect } from 'react';
import { Logger } from '#utils';

export const useLogger = ({ account }) => {
  const hasData = !!account?.id;

  useEffect(() => {
    if (!hasData) return;
    Logger.setUser({
      id: account?.id,
      email: account?.email,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasData]);
};
